import React, { PureComponent } from 'react';

import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/cosmos/button/button';
import { translate } from 'components/translate';
import { withShellContext } from 'hoc/withShellContext';
import { inject } from 'mobx-react';
import { FileLibraryProvider } from 'modules/configManager/types';
import { FeatureToggles } from 'modules/featureToggle';
import PropTypes from 'prop-types';

import FileService from '../../FileService';

import { UploadConsumer, UploadProptypes } from '@hotmart/club-files-ui';

@translate()
@withShellContext
@inject((stores) => ({
  createContentConceptToggle: stores.FeatureToggleStore.featureToggles.get(
    FeatureToggles.CreateContentConcept
  )
}))
@UploadConsumer()
export default class NewMediaButton extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    fileUpload: UploadProptypes.fileUpload,
    reusable: PropTypes.bool,
    t: PropTypes.func,
    countEntity: PropTypes.number,
    fileLibraryProvider: PropTypes.number
  };

  isButtonDisabled = () => {
    const {
      fileUpload,
      countEntity,
      createContentConceptToggle,
      isMembership
    } = this.props;
    const isNewItemsDisabled = fileUpload?.info?.isNewItemsDisabled;
    const maxFiles = fileUpload?.info?.options?.maxFilesPerEntity;
    const isConceptEnabled = createContentConceptToggle && isMembership;

    return (
      (isConceptEnabled && countEntity >= maxFiles) ||
      (!isConceptEnabled && isNewItemsDisabled)
    );
  };

  render() {
    const { reusable, t } = this.props;

    if (this.isButtonDisabled()) {
      return null;
    }

    return (
      <Button
        variation="custom"
        type="button"
        size="sm"
        onClick={reusable && this.openLibrary}
        className="file__button__new__media _bg-gray-600 _text-white _d-flex _align-items-center"
      >
        <FontAwesomeIcon icon={faPlus} className="_mr-1" />
        {t('player_section.new_media', {
          fallback: 'player_section.add_new_media'
        })}
        {!reusable && (
          <input
            type="file"
            onChange={this.onChangeInput}
            aria-label={t('player_section.add_new_media')}
          />
        )}
      </Button>
    );
  }

  openLibrary = (event) => {
    event.stopPropagation();

    const { fileUpload, fileLibraryProvider } = this.props;

    fileUpload.actions.openLibrary({
      onOpenLibrary: FileService.onLibraryOpen,
      customProvider:
        fileLibraryProvider === FileLibraryProvider.PlayerBackoffice
    });
  };

  onChangeInput = (event) => {
    const { fileUpload } = this.props;

    const files = Array.from(event.target.files);

    fileUpload.actions.sendMultiples(files);

    event.target.value = null;
  };
}
